import { inject, InjectionKey } from "@vue/composition-api";
import { MegaraxClient, Resource } from "@megarax/client/src";

export const megaraxClientKey: InjectionKey<MegaraxClient> = Symbol();

export const useMegaraxClient = () => {
  return inject(megaraxClientKey) as MegaraxClient;
};

export const useActions = <T>(resource: Resource<T>) => {
  const client = useMegaraxClient();
  return resource(client);
};
